module.exports = __webpack_public_path__ + "static/media/logo.c2ef95de.png";